var requiredValuesData = {
    "definitions":{
        "AssignmentInfo":{
            "required" : [
            	"application",
            	"stream",
            	"defaultPath",
            	"description",
            	"owner",
            	"assignmentPrefix"
            ]
        },
        "BasicAuthentication":{
			"required" : [
            	"username",
            	"password"
            ]
        },
        "EventCallback":{
			"required" : [
            	"name",
            	"url"
            ]
        },
        "HttpHeader":{
			"required" : [
            	"name",
            	"value"
            ]
        },
        "ReleaseInfo":{
			"required" : [
            	"application",
            	"stream",
            	"description"
            ]
        },
        "SetInfo":{
			"required" : [
            	"runtimeConfig"
            ]
        },
        "TaskInfo":{
        	"required" : [
            	"application",
            	"stream",
            	"moduleType",
            	"moduleName",
            	"userId",
            	"currentLevel",
            	"startingLevel"
            ]
        }
    }    
}